import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/docs-support-overview",
  "use": "navigation/docs-support-overview-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/docs-support-overview\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 2.5A1.5 1.5 0 0 1 1.5 1h13A1.5 1.5 0 0 1 16 2.5v8a1.5 1.5 0 0 1-1.5 1.5H9.35l-3.913 3.131C4.455 15.917 3 15.217 3 13.96V12H1.5A1.5 1.5 0 0 1 0 10.5v-8zM2 3v7h1.5A1.5 1.5 0 0 1 5 11.5v1.42l3.238-2.591A1.5 1.5 0 0 1 9.175 10H14V3H2z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol